/**
 * Ranks and honorifics, worn by something that has clearly not earned one.
 *
 * A shooter's vocabulary, which is half the joke: the other half is whichever noun it lands on.
 */

import type { NameWordList } from '@/identity/playerNameContract';

export const MOCK_RANKS: NameWordList = [
  'Captain',
  'Sergeant',
  'Admiral',
  'Colonel',
  'Corporal',
  'Major',
  'Commander',
  'Marshal',
  'Brigadier',
  'Deputy',
  'Baron',
  'Duke',
  'Chief',
  'Doctor',
  'Professor',
  'Inspector',
];
